<template>
  <div class="checkout-tags">
    <checkout-tag
      v-for="item in items"
      :key="item"
      :active="isActive(item)"
      :dark="dark"
      @click.native="selectTag(item)">
      {{ item }}
    </checkout-tag>
  </div>
</template>

<script>
  export default {
    name: 'checkout-tags',
    props: {
      items: Array,
      active: String,
      dark: Boolean
    },
    methods: {
      isActive (item) {
        return item === this.active
      },
      selectTag (item) {
        this.$emit('update:active', item)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .checkout-tags {
    display: flex;
  }

  .checkout-tag {
    cursor: pointer;

    &:not(.active):hover {
      background: lighten($color-dark-grey, 7%);
      color: #fff;
    }

    &.dark:not(.active):hover {
      background: lighten(#21282a, 7%);
    }

    + .checkout-tag {
      margin-left: 16px;
    }
  }
</style>
